import { graphql } from "@opensea/graphql"

export const ActivityFeedMarketplaceIconFragment = graphql(`
  fragment ActivityFeedMarketplaceIcon on Activity {
    collection {
      slug
    }
    ... on Listing {
      listingMarketplace: marketplace {
        identifier
      }
    }
    ... on Sale {
      saleMarketplace: marketplace {
        identifier
      }
    }
    ... on Mint {
      mintMarketplace: marketplace {
        identifier
      }
    }
  }
`)
